import { useState } from "react"
import api from "../lib/axios"
import { Input } from "../components/ui/input"
import { Button } from "../components/ui/button"

export default function ForgotPassword() {
  const [email, setEmail] = useState("")
  const [msg, setMsg]   = useState("")

  const handleSubmit = async () => {
    if (!email) return
    await api.post("/auth/forgot-password", { email })
    setMsg("Thank you. If your email exists, we sent a reset link.")
  }

  return (
    <div className="min-h-screen flex items-center justify-center">
      {msg ? (
        <p>{msg}</p>
      ) : (
        <div className="space-y-4 w-full max-w-sm">
          <h2 className="text-xl font-bold">Reset your password</h2>
          <Input type="email" value={email}
                 placeholder="you@example.com"
                 onChange={e => setEmail(e.target.value.trim().toLowerCase())} />
          <Button onClick={handleSubmit} className="w-full bg-black text-white">
            Send reset link
          </Button>
        </div>
      )}
    </div>
  )
}
